import { AnalyticsSession } from 'src/analytics/session';

// Distinguishes producer-made records from Pinpoint's '3.1' in the shared stream and dim table.
export const EVENT_VERSION = '4.0';

export interface EnvelopeDevice {
    make: string;
    model: string;
    platformName: string;
}

export interface EnvelopeClient {
    clientId: string;
    cognitoId?: string;
}

export interface EnvelopeInputs {
    eventType: string;
    attributes: Record<string, string>;
    session: AnalyticsSession;
    client: EnvelopeClient;
    device: EnvelopeDevice;
    now: number;
}

// Downstream reads these exact keys; do not rename, drop, or add to them.
export function buildEnvelope(inputs: EnvelopeInputs): string {
    const envelope = {
        event_type: inputs.eventType,
        event_timestamp: inputs.now,
        arrival_timestamp: inputs.now,
        event_version: EVENT_VERSION,
        client: {
            client_id: inputs.client.clientId,
            cognito_id: inputs.client.cognitoId,
        },
        device: {
            make: inputs.device.make,
            model: inputs.device.model,
            platform: {
                name: inputs.device.platformName,
            },
        },
        session: {
            session_id: inputs.session.sessionId,
            start_timestamp: inputs.session.startTimestamp,
        },
        attributes: inputs.attributes,
    };

    // Newline-delimited: records without it concatenate into one unparseable line.
    return `${JSON.stringify(envelope)}\n`;
}
